import React from 'react';
import classes from './Dropdown.module.css';

const dropdown = (props) => {
  const containerClasses = [classes.DropdownContainer];
  if (props.className) containerClasses.push(classes[props.className]);
  if (props.show) containerClasses.push(classes.Shown);
  return <div className={containerClasses.join(' ')}>{props.children}</div>;
};

export default dropdown;
